import React from 'react';
import { motion, Variants } from 'framer-motion';

const cardVariants: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, delay: i * 0.07, ease: [0.4, 0, 0.2, 1] as const },
  }),
};

interface StatCardProps {
  label: string;
  value: React.ReactNode;
  sub: string;
  icon: React.ElementType;
  badgeText: string;
  badgeColor: string;
  index: number;
}

export function StatCard({
  label,
  value,
  sub,
  icon: Icon,
  badgeText,
  badgeColor,
  index,
}: StatCardProps) {
  return (
    <motion.div
      custom={index}
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      style={{
        padding: '16px',
        borderRadius: '0',
        border: '1px solid var(--admin-card-border)',
        backgroundColor: 'var(--admin-card-bg)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
        <span style={{ fontSize: '10px', fontWeight: 600, color: 'var(--admin-card-subtext)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {label}
        </span>
        <Icon size={14} color="var(--admin-card-text)" />
      </div>
      <div style={{ fontSize: '24px', fontWeight: 700, color: 'var(--admin-card-text)', letterSpacing: '-0.02em', marginBottom: '12px', lineHeight: 1 }}>
        {value}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: '12px', color: 'var(--admin-card-subtext)' }}>{sub}</span>
        <span style={{ fontSize: '11px', fontWeight: 700, color: badgeColor }}>
          {badgeText}
        </span>
      </div>
    </motion.div>
  );
}
